export default __webpack_public_path__ + "static/media/whyus_4.c471fdba.png";